module.exports = __webpack_public_path__ + "static/media/_DSC1358.1a25d713.jpg";